import { render, staticRenderFns } from "./mailto.vue?vue&type=template&id=190ea371&scoped=true&"
import script from "./mailto.vue?vue&type=script&lang=js&"
export * from "./mailto.vue?vue&type=script&lang=js&"
import style0 from "./mailto.vue?vue&type=style&index=0&id=190ea371&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190ea371",
  null
  
)

export default component.exports